import { Auth } from "../../core/http/service/Auth";
import { CollaboratorService } from "../../core/http/service/CollaboratorService";
import { PersonService } from "../../core/http/service/PersonService";
import { UserService } from "../../core/http/service/UserService";
import User from "../../models/User";
import { AppStorage } from "../../storage/AppStorage";

export const RESET: string = "RESET";
export const LOGIN_USER: string = "LOGIN_USER";
export const LOGOUT_USER: string = "LOGOUT_USER";
export const CHANGE_CURRENT_COMPANY: string = "FETCH_CURRENT_COMPANY";
export const CHANGE_CURRENT_PROFILE: string = "CHANGE_CURRENT_PROFILE";
export const CHANGE_CURRENT_DEPENDENTE: string = "CHANGE_CURRENT_DEPENDENTE";
export const UPDATE_USER_INFO: string = "UPDATE_USER_INFO";
export const PHOTO_USER = "PHOTO_USER";
export const LOGIN_USER_DEPENDENTE = "LOGIN_USER_DEPENDENTE";


const sendToAnalytics = (action: string = "", error: any = null) => {
  console.error(action, error);
};

/**
 * User Data Types
 */
export type UserDataTypes = {
  keepConnected: boolean;
  username: string;
  password: string;
  token: string;
  refreshToken: string;
  tokenType: string;
  expirationDateMilliSeconds: number;
  dependentes: any;
};

export type UserDataTypesDependente = {
  username: string;
  token: string;
  dependentes: any;
  currentDependente: any;
};

// LOGIN PADRÃO
export const login = (userData?: UserDataTypes) => {
  const service: UserService = new UserService();
  const servicePerson: PersonService = new PersonService();
  return async (dispatch: any) => {
    try {

      if (userData) {
        const { token, username, refreshToken, keepConnected, tokenType } =
          userData;
        await AppStorage.saveToken(false, token);
        await AppStorage.saveToken(true, refreshToken);
        await AppStorage.saveCookie("USER", username);
        let userInfo = null;
        let photo = null;

        if (tokenType !== "reset_password") {
          const userInfoResponse: any = await service.getInfo();
          userInfo = userInfoResponse.data.data;
          if (userInfo.foto !== null) {

            try {

              const photoUser: any = await servicePerson.getPhoto(userInfo.foto);

              const blob = new Blob([photoUser.data], {
                type: photoUser.headers["content-type"],
              });

              const image = URL.createObjectURL(blob);

              photo = image;

            } catch (error) {
              console.log(error)
            }

          }
        }

        const empresas = userInfo === null ? null : userInfo.empresas;
        const currentCompany =
          userInfo === null
            ? null
            : userInfo.empresas.length > 0
              ? userInfo.empresas[0]
              : null;
        const perfil =
          userInfo === null
            ? null
            : userInfo.empresas.length > 0
              ? userInfo.empresas[0].perfis[0]
              : null;

        if (tokenType !== "reset_password") {
          const colaborador = new CollaboratorService();

          const body = {
            empresaId: currentCompany.id,
            cpf: username,
            maiorIdade: true,
            todosDependentes: true
          };


          localStorage.setItem('currentCompany', JSON.stringify(currentCompany));
          localStorage.setItem('currentProfile', userInfo.empresas[0].perfis[0]);

          const dependentes: any = await colaborador.BuscarUsuariosDoResponsavel(body);

          if (dependentes && dependentes.data && dependentes.data.data && dependentes.data.data.length > 0) {
            var listaDependentesColaborador = dependentes.data.data;
            var currentDependente = listaDependentesColaborador.find((d: any) => d.responsavel === true);
          }
        }

        dispatch({
          token,
          refreshToken,
          username,
          keepConnected,
          userInfo: userInfo,
          currentCompany: currentCompany,
          companies: empresas,
          currentRole: perfil,
          tokenType,
          photo: photo,
          type: LOGIN_USER,
          dependentes: listaDependentesColaborador ? listaDependentesColaborador.sort((a: any, b: any) => a.nome.localeCompare(b.nome)) : null,
          currentDependente: currentDependente,
          dependenteProfile: currentDependente && currentDependente.responsavel ? false : true
        });
      }
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

// LOGIN MENU LATERAL
export const loginMenuLateral = (dados: UserDataTypesDependente) => {

  const service: UserService = new UserService();
  const servicePerson: PersonService = new PersonService();
  return async (dispatch: any) => {
    try {

      let tokenInicial: any = dados.token;

      //Login Usuário
      const auth = new Auth();
      const loginResponse: any = await auth.postAuthUsuario({
        User: dados.currentDependente.cpf,
        Token: tokenInicial.token
      });

      const token = loginResponse.data.data;
      //Atualizar novamente o token
      await AppStorage.saveToken(false, token.token);
      await AppStorage.saveToken(true, token.refreshToken);
      await AppStorage.saveCookie("USER", dados.currentDependente.cpf);

      //Pegar informações
      let userInfoResponse: any = await service.getInfo();
      let userInfo: any = userInfoResponse.data.data;

      let photo = null;

      if (dados && dados.currentDependente !== null && dados.currentDependente.foto != null) {
        const photoUser: any = await servicePerson.getPhoto(dados.currentDependente.foto);

        const blob = new Blob([photoUser.data], {
          type: photoUser.headers["content-type"],
        });

        const image = URL.createObjectURL(blob);

        photo = image;
      }

      const empresas = userInfo === null ? null : userInfo.empresas;
      const currentCompany =
        userInfo === null
          ? null
          : userInfo.empresas.length > 0
            ? userInfo.empresas[0]
            : null;
      const perfil =
        userInfo === null
          ? null
          : userInfo.empresas.length > 0
            ? userInfo.empresas[0].perfis[0]
            : null;

      dispatch({
        token: token.token,
        refreshToken: token.refreshToken,
        username: dados.username,
        keepConnected: true,
        userInfo: userInfo,
        currentCompany: currentCompany,
        companies: empresas,
        currentRole: perfil,
        tokenType: token.tokenType,
        photo: photo,
        type: LOGIN_USER_DEPENDENTE,
        dependentes: dados.dependentes ? dados.dependentes.sort((a: any, b: any) => a.nome.localeCompare(b.nome)) : null,
        currentDependente: dados.currentDependente,
        dependenteProfile: dados.currentDependente.responsavel ? false : true
      });

    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const updateUserInfo = () => {
  const service: UserService = new UserService();
  return async (dispatch: any) => {
    try {
      const userInfoResponse: any = await service.getInfo();
      const userInfo: any = userInfoResponse.data.data;

      const empresas = userInfo === null ? null : userInfo.empresas;
      const currentCompany =
        userInfo === null
          ? null
          : userInfo.empresas.length > 0
            ? userInfo.empresas[0]
            : null;
      const perfil =
        userInfo === null
          ? null
          : userInfo.empresas.length > 0
            ? userInfo.empresas[0].perfis[0]
            : null;

      dispatch({
        type: UPDATE_USER_INFO,
        userInfo: userInfo,
        currentCompany: currentCompany,
        companies: empresas,
        currentRole: perfil,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const retrievePassword = (user: string, email: string) => {
  const service: Auth = new Auth();
  return async (dispatch: any) => {
    try {
      const callBackUrl = process.env.REACT_APP_CALLBACK_URL; //Mudar esse callback de acordo com o ambiente
      const params = {
        user: user,
        email: email,
        callbackUrl: callBackUrl,
      };
      /*Salvando em cookie o user e o email*/
      await AppStorage.saveCookie("userRetrievePassword", user);
      await AppStorage.saveCookie("emailRetrievePassword", email);
      await service.forgotPassword(params);
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const changePassword = (
  user: User,
  newPassword: string,
  code: string
) => {
  const service: Auth = new Auth();
  return async (dispatch: any) => {
    try {
      const params = {
        user: user.user,
        email: user.email,
        code: decodeURIComponent(code),
        password: newPassword,
      };

      await service.resetPassword(params);
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const changeCurrentCompany = (company: any) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: CHANGE_CURRENT_COMPANY,
        currentCompany: company,
        currentProfile: company.perfis[0],
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const changeCurrentProfile = (profile: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: CHANGE_CURRENT_PROFILE,
        currentProfile: profile,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const changeCurrentDependente = (dependente: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: CHANGE_CURRENT_DEPENDENTE,
        currentDependente: dependente,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const photoUser = () => {
  return async (dispatch: any) => {
    const service: UserService = new UserService();
    const servicePerson: PersonService = new PersonService();
    try {
      const userInfoResponse: any = await service.getInfo();
      const userInfo = userInfoResponse.data.data;
      const photoUser: any = await servicePerson.getPhoto(userInfo.foto);

      const blob = new Blob([photoUser.data], {
        type: photoUser.headers["content-type"],
      });

      const image = URL.createObjectURL(blob);

      dispatch({
        type: PHOTO_USER,
        photo: image,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const logout = () => {
  return async (dispatch: any) => {
    try {
      await AppStorage.removeCookie(AppStorage.ACCESS_TOKEN);
      await AppStorage.removeCookie(AppStorage.REFRESH_TOKEN);
      await AppStorage.removeCookie("USER");
      dispatch({
        type: LOGOUT_USER,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};
